import { render } from "./StockSection.vue?vue&type=template&id=3c87a448&scoped=true&ts=true"
import script from "./StockSection.vue?vue&type=script&lang=ts"
export * from "./StockSection.vue?vue&type=script&lang=ts"

import "./StockSection.vue?vue&type=style&index=0&id=3c87a448&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c87a448"]])

export default __exports__